export default "__VITE_ASSET__Cf5WIJX5__"